import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Btn,
  CentraisOperacaoDropdown,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomPanel,
  DateTime,
  NumeroDecimal,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import Modal from './ModalCicloEntrega'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { selectedCicloChanged } from '../../../../store/actions/ciclo-entrega.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import useCicloEntrega, { LOAD_MESSAGE } from './CicloEntregaHook'
import { FaTrash } from 'react-icons/fa'
import { CustomDropdown, InputText } from '../../../../components'
import { Fieldset } from 'primereact/fieldset'

function CicloEntrega({ dispatch, history }) {
  const { state, localDispatch } = useCicloEntrega()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SUCCESS_DELETE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteDeliveryCycle(state.selectedCiclo)
        break

      case LOAD_MESSAGE.GET_DELIVERY_CICLES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getDeliveriesCycles(
          state.selectedCentral,
          state.periodo.dataInicial,
          state.periodo.dataFinal,
        )
        break

      case LOAD_MESSAGE.GET_DELIVERY_CICLES_FILTRO:
        dispatch(showLoadingBox('Aguarde...', 'Filtrando ciclos'))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      const { id, name, company_id, company_de, file_type_id, operationcenter_id } =
        state.selectedCiclo
      dispatch(
        selectedCicloChanged(id, name, company_id, file_type_id, operationcenter_id, company_de),
      )
      history.push(state.pathToRedirect, {
        ciclo: state.selectedCiclo,
        central_operacional_id: state.selectedCentral,
      })
    }
  }, [state.pathToRedirect])

  return (
    <div>
      <PageHeader>3.1 - Ciclos de Entrega</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={localDispatch.onBtnNovo} onVoltar={history.goBack}>
          <React.Fragment>
            <div className="p-grid">
              <div className="p-col-4" style={{ paddingTop: 35 }}>
                <CentraisOperacaoDropdown
                  value={state.selectedCentral}
                  onChange={value =>
                    localDispatch.onCentralOperacoesChange(
                      value,
                      state.periodo.dataInicial,
                      state.periodo.dataFinal,
                    )
                  }
                />
              </div>
              <div className="p-col-3">
                <Periodo
                  periodoFinal={state.periodo.dataFinal}
                  periodoInicial={state.periodo.dataInicial}
                  onPesquisar={localDispatch.onPesquisar}
                />
              </div>
              {localDispatch.verifyMenuItemAllowed({ id: 41, content: 'Gerar Multi-Ciclos' }) && (
                <div className="p-col-2" style={{ paddingTop: 35 }}>
                  <Btn onClick={localDispatch.onGerarMultiCiclos}>Gerar Multi-Ciclos</Btn>
                </div>
              )}
              <div className="p-col-2" style={{ paddingTop: 35 }}>
                <Btn onClick={() => history.push('/main/entregas/logs-xml-robot')}>Logs XML-Robot</Btn>
              </div>
              <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12">
                <div className="p-grid p-align-center">
                  <div className="p-col-6">
                    <CustomDropdown
                      label="Empresa"
                      optionLabel="name"
                      options={state.companies}
                      value={state.selectedCompany}
                      onChange={v => localDispatch.onFiltroChange('selectedCompany', v)}
                      placeholder="Selecione"
                      filter
                    />
                  </div>
                  <div className="p-col-4">
                    <InputText
                      label="Nota Fiscal"
                      value={state.notaFiscal}
                      onChange={v => localDispatch.onFiltroChange('notaFiscal', v)}
                    />
                  </div>
                  <div className="p-col-2" style={{ marginTop: 32 }}>
                    <Btn onClick={localDispatch.onBuscarFiltrado}>Buscar</Btn>
                  </div>
                </div>
              </Fieldset>
            </div>
            <div style={{ marginTop: 15 }}>
              <DataTable
                value={state.ciclos}
                dataKey="id"
                rowKey="id"
                emptyMessage="Não existe Ciclo para o Centro de Operações e Períodos Selecionados"
                globalFilter={state.globalFilter}
                header={
                  <CustomDataTableHeader
                    onChange={value => localDispatch.setGlobalFilter(value)}
                    value={state.globalFilter}
                  />
                }
                rows={15}
                paginator
              >
                <Column field="id" header="Código" style={tableCellCentered()} />
                <Column field="created_at" header="Data Importação" style={tableCellCentered()} />
                <Column field="name" header="Ciclo de Entrega" />
                <Column field="referencia" header="Referência" bodyStyle={tableCellCentered()} />
                <Column
                  field="deadline"
                  header="Deadline"
                  style={tableCellCentered()}
                  body={ciclo => <DateTime>{ciclo.deadline}</DateTime>}
                  bodyStyle={tableCellCentered()}
                />
                <Column field="company" header="Empresa" style={{ width: 200 }} />
                <Column
                  field="qte_sku_total"
                  style={tableCellCentered(100)}
                  header="Qtd Volumes"
                  body={i => {
                    if (!i.qte_sku_total) {
                      return null
                    }
                    return <NumeroDecimal>{i.qte_sku_total}</NumeroDecimal>
                  }}
                />
                <Column
                  field="peso_total"
                  style={tableCellCentered(100)}
                  header="Peso Total"
                  body={i => {
                    if (!i.peso_total) {
                      return null
                    }
                    return <NumeroDecimal>{i.peso_total}</NumeroDecimal>
                  }}
                />
                <Column
                  field="type"
                  header="Tipo"
                  style={{ width: 200, textTransform: 'capitalize' }}
                  body={ciclo =>
                    ciclo.type === 'recebimento-de-para'
                      ? 'Recebimento - Estoque - DePara'
                      : ciclo.type
                  }
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={ciclo => (
                    <ThreeDots
                      items={localDispatch.getMenuItems()}
                      onClick={item => localDispatch.onMenuItemClicked(item, ciclo)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
                {localDispatch.verifyMenuItemAllowed({ id: 32, content: 'Apagar' }) && (
                  <Column
                    header=""
                    style={tableCellCentered(70)}
                    body={ciclo => (
                      <FaTrash
                        style={{ cursor: 'pointer' }}
                        color="red"
                        onClick={() => localDispatch.onMenuItemClicked('Apagar', ciclo)}
                      />
                    )}
                    bodyStyle={tableCellCentered()}
                  />
                )}
              </DataTable>
            </div>
          </React.Fragment>
        </CustomPanel>
      </div>
      <Modal
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        data={state.modal.data}
      />
      <ConfirmDialog
        isVisible={state.modalConfirmDelete.show}
        title="Atenção"
        content={<span>Tem certeza que deseja excluir o ciclo de entrega?</span>}
        onCancelar={localDispatch.onModalDeleteClose}
        onOk={() => localDispatch.onModalDeleteSave(state.modalConfirmDelete.data)}
      />
    </div>
  )
}

export default connect()(withRouter(CicloEntrega))
